import request from '@/utils/request'

/**
 * 获取基本信息
 * @param {*} params iccid：iccidnum
 * @returns
 */
export const rechargeList = params => {
  return request({
    method: 'post',
    url: '/cm/eqp/mobileQuery',
    params
  })
}

/**
 * 授权
 * @param {*} params -> { tradeType: tradeTypenum, payId: payIdnum}
 * @returns
 */
export const authorize = params => {
  return request({
    method: 'get',
    url: '/wechat/authorize',
    params
  })
}

/**
 * 获取用户信息
 * @param {*} params -> { tradeType: tradeTypenum, payId: payIdnum}
 * @returns
 */
export const getUserInfo = params => {
  return request({
    method: 'get',
    url: '/wechat/userInfo',
    params
  })
}

/**
 * 折线图数据
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const getLineChart = params => {
  return request({
    method: 'GET',
    url: '/Sim/ListFlow',
    params
  })
}

/**
 * 移动 折线图数据 查数据库
 * @param {*} params
 * @returns
 */
export const billList = (eqpId) => {
  return request({
    method: 'GET',
    url: '/cm/eqp/billList/' + eqpId
  })
}

/**
 * 充值查询是否需要支付
 * @param {*} params ->  iccid：iccidnum
 * @returns
 */
export const rechargeSubmit = params => {
  return request({
    method: 'post',
    url: '/cm/eqp/mobileRecharge',
    params
  })
}

/**
 * 流量充值
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const RechargeFlow = params => {
  return request({
    method: 'POST',
    url: '/cm/eqp/mobileAddFlow',
    params
  })
}
/**
 * 流量包充值
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const RechargeFlowV2 = params => {
  return request({
    method: 'POST',
    url: '/cm/eqp/mobileAddFlowV2',
    params
  })
}
/**
 * 充值
 * @param {*} params -> { tradeType: tradeTypenum, payId: payIdnum}
 * @returns
 */
export const payUnifiedOrder = params => {
  return request({
    method: 'post',
    url: '/pay/createOrder',
    params
  })
}
export const payUnifiedOrderV2 = params => {
  return request({
    method: 'post',
    // url: '/pay/createOrder',
    url: '/channel/pay/createOrder',
    params
  })
}

/**
 * 查询订单支付成功与否
 * @param {*} params { order_id: orderId }
 * @returns
 */
export const findOrder = params => {
  return request({
    method: 'POST',
    url: '/cm/eqp/rechargeQueryOrderStatus',
    params
  })
}

/**
 * 查询订单支付成功与否
 * @param {*} params { order_id: orderId }
 * @returns
 */
export const findOrderV2 = params => {
  return request({
    method: 'POST',
    url: '/cm/eqp/rechargeQueryOrderStatusV2',
    params
  })
}

/**
 * 查询订单业务跳转
 * @param {*} params { order_id: orderId }
 * @returns
 */
export const findOrderJump = params => {
  return request({
    method: 'post',
    url: '/mobile/order/jump',
    params
  })
}

/**
 * 移动PB 查询流量同步
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const yiDongPb = params => {
  return request({
    method: 'POST',
    url: '/Sim/UpdateOldChinaMobile',
    params
  })
}

/**
 * 新移动(移动CT 同步
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const newYiDong = params => {
  return request({
    method: 'POST',
    url: '/syn/updateNewMove',
    params
  })
}

/**
 * 联通 同步
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const lianTong = params => {
  return request({
    method: 'POST',
    url: '/Sim/UpdateUMMove',
    params
  })
}

/**
 * 移动PB 充值同步
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const yiDongPbCZ = params => {
  return request({
    method: 'POST',
    url: '/Sim/RenewOldChinaMobile',
    params
  })
}

/**
 * 移动CT2刷新调用
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const YDCTReact = params => {
  return request({
    method: 'POST',
    url: '/syn/updateNewMove',
    params
  })
}
